
import LogosGrid from './LogosGrid';
import { useEffect, useRef } from 'react';
import OptimizedImage from '@/components/ui/optimized-image';

const HeroContentCard = () => {
  const imageRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    // Log when the largest contentful paint image is loaded
    if (imageRef.current && imageRef.current.complete) {
      console.info('Hubspot script loaded successfully');
    }
  }, []);

  return (
    <div className="relative mt-8 lg:mt-0 flex justify-center">
      <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 animate-fade-in max-w-md w-full">
        {/* Updated with the new funnel image */}
        <div className="flex justify-center items-center mb-6">
          <OptimizedImage
            src="/lovable-uploads/2aae972c-086f-4af5-aa3f-886b1a17c066.png"
            alt="How open reqs become emergencies"
            className="max-w-full h-auto"
            width={500}
            height={300}
            priority={true}
          />
        </div>

        {/* Logo rows */}
        <LogosGrid />
      </div>
    </div>
  );
};

export default HeroContentCard;
